import { render, staticRenderFns } from "./IntervalRelation.vue?vue&type=template&id=4b98f4d6&scoped=true&"
import script from "./IntervalRelation.vue?vue&type=script&lang=js&"
export * from "./IntervalRelation.vue?vue&type=script&lang=js&"
import style0 from "./IntervalRelation.vue?vue&type=style&index=0&id=4b98f4d6&prod&scoped=true&lang=css&"
import style1 from "./IntervalRelation.vue?vue&type=style&index=1&id=4b98f4d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b98f4d6",
  null
  
)

export default component.exports